import React, { useEffect, useState } from "react";
import "./Css/Expereince.css";
import LoadingSpinner from "./LoadingSpinner";

import img1 from "./Css/comImage1.jpg";
import img2 from "./Css/comImage2.jpg";
import img3 from "./Css/comImage3.jpg";

const associateImages = [
  { src: img1, alt: "Associate Software Engineer 1" },
  { src: img2, alt: "Associate Software Engineer 2" },
];

const Experience = () => {
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 700);

    return () => clearTimeout(timer);
  }, []);

  const prevImage = () => {
    setCurrentIndex(
      currentIndex === 0 ? associateImages.length - 1 : currentIndex - 1
    );
  };

  const nextImage = () => {
    setCurrentIndex(
      currentIndex === associateImages.length - 1 ? 0 : currentIndex + 1
    );
  };

  return (
    <div className="experience-container">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="experience-wrapper">
          {/* REDBLOCKS */}
          <div className="experience-row">
            <div className="experience-text">
              <h2>Software Engineer</h2>
              <p>2025 - 2026</p>
              <p className="company">@Redblocks</p>
              <p>
                Worked on enterprise-level applications using Vue, TypeScript,
                and Spring Boot. Used Docker, Git, Odoo (Odoo.sh & Studio), and
                Playwright for testing. Focused on scalable systems and
                performance.
              </p>
            </div>

            <div className="experience-image-box">
              <img src={img3} alt="Redblocks" />
            </div>
          </div>

          {/* ASSOCIATE */}
          <div className="experience-row">
            <div className="experience-text">
              <h2>Associate Software Engineer</h2>
              <p>June 2023 - 2025</p>
              <p className="company">@Hasthiya IT</p>
              <p>
                Worked on full-stack applications using React, Next.js, Node.js,
                Vue, Laravel, and databases. Delivered efficient solutions in
                team environments.
              </p>
            </div>

            <div className="experience-image-box slider">
              <button className="arrow left" onClick={prevImage}>
                &#10094;
              </button>

              <img
                src={associateImages[currentIndex].src}
                alt={associateImages[currentIndex].alt}
              />

              <button className="arrow right" onClick={nextImage}>
                &#10095;
              </button>
            </div>
          </div>

          {/* INTERN */}
          <div className="experience-row">
            <div className="experience-text">
              <h2>Intern Software Engineer</h2>
              <p>November 2022 - 2023</p>
              <p className="company">@Hasthiya IT</p>
              <p>
                Worked on enterprise applications using React and Spring Boot,
                handling both SQL and NoSQL databases including Firebase.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Experience;
